import { all } from 'redux-saga/effects';

import fromClientFrontendHandlers from '../app-communication/sagas/from-client-frontend-handlers';
import fromClusterHandlersSaga from '../app-communication/sagas/from-cluster-handlers';
import fromMainAppHandlers from '../app-communication/sagas/from-main-app-handlers';
import requestsCompletion from '../app-communication/sagas/requests-completion';
import notifications from '../app-communication/sagas/notifications';
import reconnectLogger from '../app-communication/sagas/reconnect-logger';

import fileUpload from './file-upload';
import i18n from './i18n';
import sgDialog from './sg-dialog';

export default function* sagas() {
  yield all([
    i18n(),
    fileUpload(),
    fromClientFrontendHandlers(),
    fromClusterHandlersSaga(),
    fromMainAppHandlers(),
    requestsCompletion(),
    sgDialog(),
    notifications(),
    reconnectLogger()
  ]);
}
